import { useManagerCtxSelector } from '../../../../xstate/app.xstate';

/** False until this org's details load: a stale org's parentId must not decide it. */
export const useIsRootOrg = (orgId: string): boolean =>
  useManagerCtxSelector(
    (ctx) => ctx.orgDetails?.id === orgId && !ctx.orgDetails.parentId
  );
